(window as any)["RtcUtils"] = (window as any)["RtcUtils"] || {};

/* Typings to be exposed to library user */
export * from "./output/interfaces";
export * from "./output/version";
export { version as PackageVersion } from "./output/genversion";
export * from "./output/utils";
export * from "./output/settings";
export * from "./output/eventemitter";
export * from "./output/logger";
export * from "./output/platform";
export * from "./output/enumnames";
export * from "./output/legacylogemitter";
export * from "./output/workerutils";
export * from "./output/translateplatform";
export * from "./output/extensions";
export { TracingManager } from "./output/tracingmanager";
export * from "./output/observablearray";
export * from "./output/cancellablewait";
export * from "./output/types";
export * from "./output/internaltypes";
export * from "./output/telemetry";
